import { inject, Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { LoadMaintanenceMessages, MaintenanceMessagesState } from './maintenance-messages-state';
import { MaintenanceMessagesResponse } from '../models/maintenance-messages-response';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceMessageService {
  private readonly store: Store = inject(Store);

  public readonly message$: Observable<MaintenanceMessagesResponse> = this.store.select(MaintenanceMessagesState.getMaintananceMessage);

  public loadData(): void {
    this.store.dispatch(new LoadMaintanenceMessages());
  }
}
